import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { NgClass } from '@angular/common';
import { IconComponent } from "../icon/icon.component";
import { IonBadge } from '@ionic/angular/standalone';

@Component({
  selector: 'lib-floating-button',
  imports: [NgClass, IconComponent, IonBadge],
  templateUrl: './floating-button.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FloatingButton { 


  clicked = output<void>();

  position = input<
    'top-right' | 'top-left' |
    'middle-right' | 'middle-left' |
    'bottom-right' | 'bottom-left'
  >('bottom-right');


  icon = input<string | undefined>(undefined);
  label = input<string | undefined>(undefined);
  badge = input<number | undefined>(undefined);
  variant = input<'circle' | 'rectangle'>('circle');
  size = input<'sm' | 'md' | 'lg'>('md');


  positionClasses = computed(() => {
    const pos = this.position();
    const common = 'fixed z-[9999]';
    const positions: Record<string, string> = {
      'top-right': `${common} top-6 right-6`,
      'top-left': `${common} top-6 left-6`,
      'middle-right': `${common} top-1/2 right-6 -translate-y-1/2`,
      'middle-left': `${common} top-1/2 left-6 -translate-y-1/2`,
      'bottom-right': `${common} bottom-6 right-6`,
      'bottom-left': `${common} bottom-6 left-6`,
    };
    return positions[pos] ?? positions['bottom-right'];
  });



  //? classes condicionals segons variant 
  buttonClasses = computed(() => {
    const v = this.variant();
    const s = this.size();

    const base = 'flex items-center justify-center bg-white text-gray-700 border border-gray-200 shadow-xl transition-transform hover:scale-105 active:scale-95 cursor-pointer active:bg-brand-500';
    const radius = v === 'circle' ? 'rounded-full' : 'rounded-2xl';

    const dims = v === 'circle'
      ? (s === 'sm' ? 'w-[48px] h-[48px]' : s === 'lg' ? 'w-[96px] h-[96px]' : 'w-[72px] h-[72px]')
      : (s === 'sm' ? 'w-[96px] h-[48px]' : s === 'lg' ? 'w-[192px] h-[96px]' : 'w-[144px] h-[72px]');

    return `${base} ${radius} ${dims}`;
  });



  onClick() {
    this.clicked.emit();
  }

}